import React from 'react'
import { ProductWithActiveColour } from '../../types'
import { ProductBlock } from './ProductBlock'

interface Props {
  product: ProductWithActiveColour
}

export const Product: React.FC<Props> = ({ product }) => (
  <div className="productlist-product">
    <ProductBlock product={product} />
  </div>
)
